export const ROOT_PATH = '/';
export const ACCOUNT_SETTINGS_PATH = '/account-settings';
export const MY_UPDATES_PATH = '/updates';
export const ADMIN_ROLE_PAGE_PATH = '/administration/roles';
export const ADMIN_REPORTS_PAGE_PATH = '/administration/reports';
